import { LogLevelType } from '../types/logger';

// Logging
export const isLoggingEnabled = process.env.REACT_APP_ENV_ENABLE_LOGGING === '1';
export const configLogLevel: LogLevelType = process.env.REACT_APP_LOG_LEVEL as LogLevelType;
